import React, { Component } from 'react';
import { GiPartyPopper } from "react-icons/gi";
import { IoCheckmarkDone } from "react-icons/io5";
import { MdMoodBad } from "react-icons/md";
import { VscError } from "react-icons/vsc";
import { Link } from 'react-router-dom';



class DisplayExamScore extends Component {
    state = {
        isActive: false,
        windowHeight: window.innerHeight - 60,
        error: null,
        loading: false, // Added loading state
    };
    // for the image 
    fileInputRef = React.createRef();










    // start of the handle submition




    // the display
    handleOutsideClick = (event) => {
        if (this.node && !this.node.contains(event.target)) {
            this.setState({ isActive: false, });
            // this.props.handleToggle()
        }

    };
    componentDidMount() {
        window.addEventListener('resize', this.handleResize);
        document.addEventListener('mousedown', this.handleOutsideClick);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize);
        document.removeEventListener('mousedown', this.handleOutsideClick);
    }
    handleResize = () => {
        this.setState({ windowHeight: window.innerHeight - 60 });
    };


    render() {
        const res = this.props.response

        return (

            <div className="dash_add_course_cover" style={{ width: "100%", height: this.state.windowHeight, display: "flex" }}>
                <div className="dash_form_container" ref={(node) => (this.node = node)}>
                    <h2>Exam Score</h2>
                    <div className='score_container'>
                        <h5 className='score'>
                           {res.passed ? <GiPartyPopper style={{color:"green"}}/> :
                            <MdMoodBad style={{ color: "red" }} />}
                            {res.score}%
                        </h5>
                        {res.passed ? 
                        <p className='score' style={{color: "green"}}>
                            <IoCheckmarkDone />
                            Score : Pass
                        </p>:
                        <p className='score' style={{color:"red"}}>
                            <VscError />
                            Score : Failed
                        </p>}
                        <h4 className='score'>{res.correct_answers}/{res.total_questions} questions</h4>
                        <Link to="/dashboard"><button>Back To Dashboard</button></Link>
                    </div>
                </div>
            </div>


        );
    }
}

export default DisplayExamScore;